// standard top columns
export const DOB: CMxCommonApp.PatientDataDefinition = {
  key: 'patient-dob',
  label: 'DOB',
  property: 'date_of_birth',
  transformer: 'friendly_date',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};
export const DOB_AGE_BY_DOS: CMxCommonApp.PatientDataDefinition = {
  key: 'patient-dob',
  label: 'DOB',
  property: 'date_of_birth',
  transformer: 'dob_age_by_dos',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const GENDER: CMxCommonApp.PatientDataDefinition = {
  key: 'patient-gender',
  label: 'Gender',
  property: 'patient_gender',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const MRN: CMxCommonApp.PatientDataDefinition = {
  key: 'patient-mrn',
  label: 'MRN',
  property: 'patient_identifier',
  transformer: 'mrn',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

// standard mid columns
export const ACCESSION: CMxCommonApp.PatientDataDefinition = {
  key: 'accession',
  label: 'Accession',
  property: 'primary_clinical_identifier',
  transformer: 'identifier',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const EXAM_CODE: CMxCommonApp.PatientDataDefinition = {
  key: 'exam_code',
  label: 'Exam Code',
  property: 'exam_code',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const PRIMARY_INSURANCE: CMxCommonApp.PatientDataDefinition = {
  key: 'primary_insurance',
  label: 'Primary Insurance',
  property: 'primary_insurance',
  dataSize: 'l',
  dataSizeHorizontalView: 'l'
};

export const REASON_FOR_VISIT: CMxCommonApp.PatientDataDefinition = {
  key: 'reason_for_visit',
  label: 'Reason for Visit',
  property: 'reason_for_visit',
  dataSize: 'm',
  dataSizeHorizontalView: 'l'
};

export const GLOBAL_PERIOD: CMxCommonApp.PatientDataDefinition = {
  key: 'global_period',
  label: 'Global Period',
  property: 'global_period',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const DOS: CMxCommonApp.PatientDataDefinition = {
  key: 'date_of_service',
  label: 'Date of Service',
  property: 'date_of_service',
  dataSize: 'l',
  transformer: 'date_of_service',
  fieldType: 'date',
  dataSizeHorizontalView: 'l'
};

export const EXAM_DESCRIPTION: CMxCommonApp.PatientDataDefinition = {
  key: 'exam_description',
  label: 'Exam Description',
  property: 'exam_description',
  dataSize: 'l',
  dataSizeHorizontalView: 'l'
};

// standard bottom columns

export const ORDERING_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'ordering_provider_name',
  label: 'Ordering Provider',
  property: 'ordering_provider_name',
  dataSize: 'l',
  dataSizeHorizontalView: 'l'
};

export const ORDERING_PROVIDER_NUMBER: CMxCommonApp.PatientDataDefinition = {
  key: 'ordering_provider_number',
  label: 'Ordering Provider ID',
  property: 'ordering_provider_number',
  transformer: 'numerical',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const ORDER_NUMBER: CMxCommonApp.PatientDataDefinition = {
  key: 'order_number',
  label: 'Order ID',
  property: 'order_number',
  transformer: 'numerical',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const PLACE_OF_SERVICE: CMxCommonApp.PatientDataDefinition = {
  key: 'place_of_service',
  label: 'Place of Service',
  property: 'place_of_service',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const TENANT_NAME: CMxCommonApp.PatientDataDefinition = {
  key: 'tenant_name',
  label: 'Tenant Name',
  property: 'tenant_name',
  dataSize: 'm',
  dataSizeHorizontalView: 'l'
};

export const BILLING_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'billing_provider_name',
  label: 'Billing Provider',
  property: 'billing_provider_name',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const BILLING_PROVIDER_NUMBER: CMxCommonApp.PatientDataDefinition = {
  key: 'billing_provider_number',
  label: 'Billing Provider ID',
  property: 'billing_provider_number',
  transformer: 'numerical',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const PROCEDURE_TYPE: CMxCommonApp.PatientDataDefinition = {
  key: 'procedure_type',
  label: 'Procedure Type',
  property: 'procedure_type',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const PROCEDURE_TYPE_CATEGORY: CMxCommonApp.PatientDataDefinition = {
  key: 'procedure_type_category',
  label: 'Procedure Type',
  property: 'procedure_type_category',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const VISIT_NUMBER: CMxCommonApp.PatientDataDefinition = {
  key: 'visit_number',
  label: 'Visit Number',
  transformer: 'numerical',
  property: 'visit_number',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const CASE_ID: CMxCommonApp.PatientDataDefinition = {
  key: 'case_id',
  label: 'CMX Case ID',
  property: 'case_id',
  dataSize: 'l',
  dataSizeHorizontalView: 'l'
};

// PATH SPECIFIC

export const SPECIMEN_SOURCES: CMxCommonApp.PatientDataDefinition = {
  key: 'specimen_sources',
  label: 'Primary Specimen Source',
  transformer: 'specimen_sources',
  property: 'specimen_sources',
  dataSize: 'm',
  dataSizeHorizontalView: 'l'
};

export const GROUPER: CMxCommonApp.PatientDataDefinition = {
  key: 'grouper',
  label: 'Specimen category',
  property: 'grouper',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const HAR: CMxCommonApp.PatientDataDefinition = {
  key: 'hospital_account_record',
  label: 'Hospital Account Record',
  property: 'hospital_account_record',
  dataSize: 'l',
  dataSizeHorizontalView: 'l'
};

export const ENCOUNTER_NUMBER = {
  ...HAR,
  label: 'Encounter'
};

export const PROCESS_ID: CMxCommonApp.PatientDataDefinition = {
  key: 'case_json_id',
  label: 'CMX Process ID',
  property: 'case_json_id',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const CASE_TYPE: CMxCommonApp.PatientDataDefinition = {
  key: 'case_type',
  label: 'Case Type',
  property: 'case_type',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

// surg columns

export const SCHEDULED_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'primary_provider_name',
  label: 'Scheduled Provider',
  property: 'primary_provider_name',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const SCHEDULED_PROVIDER_NUMBER: CMxCommonApp.PatientDataDefinition = {
  key: 'ordering_provider_number',
  label: 'Ordering Provider ID',
  property: 'ordering_provider_number',
  transformer: 'numerical',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const BILLING_AREA: CMxCommonApp.PatientDataDefinition = {
  key: 'billing_area',
  label: 'Billing Area',
  property: 'billing_area',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const DEPARTMENT: CMxCommonApp.PatientDataDefinition = {
  key: 'scheduling_department',
  label: 'Department',
  property: 'scheduling_department',
  dataSize: 'l',
  dataSizeHorizontalView: 'l'
};

export const SPECIALTY: CMxCommonApp.PatientDataDefinition = {
  key: 'specialty',
  label: 'Specialty',
  property: 'specialty',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

// Automate/IPC columns

export const FINANCIAL_STATUS_CLASS: CMxCommonApp.PatientDataDefinition = {
  key: 'financial_status_class',
  label: 'Financial Status Class',
  property: 'financial_status_class',
  dataSize: 'l',
  dataSizeHorizontalView: 'l',
  fieldType: 'dictionary'
};

export const FACILITY: CMxCommonApp.PatientDataDefinition = {
  key: 'billing_location',
  label: 'Facility',
  property: 'billing_location',
  dataSize: 'l',
  dataSizeHorizontalView: 'l',
  fieldType: 'dictionary'
};

export const PATIENT_CLASS: CMxCommonApp.PatientDataDefinition = {
  key: 'patient_class',
  label: 'Patient Class',
  property: 'patient_class',
  dataSize: 'l',
  dataSizeHorizontalView: 'l'
};

export const PATIENT_TYPE: CMxCommonApp.PatientDataDefinition = {
  key: 'patient_type',
  label: 'Patient Type',
  property: 'patient_type',
  dataSize: 'l',
  dataSizeHorizontalView: 'l',
  fieldType: 'dictionary'
};

export const AUTHENTICATOR_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'assigned_document_auth_name',
  label: 'Authenticator',
  property: 'assigned_document_auth_name',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l',
  hasLink: true,
  additionalInfo: [
    {
      property: 'assigned_document_auth_number',
      label: 'providerNumber'
    },
    {
      property: 'facility',
      label: 'tenantCode'
    },
    {
      property: 'assigned_document_auth_name',
      label: 'providerName'
    }
  ]
};

export const ADMITTING_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'admitting_provider_name',
  label: 'Admitting Provider',
  property: 'admitting_provider_name',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l',
  hasLink: true,
  additionalInfo: [
    {
      property: 'admitting_provider',
      label: 'providerNumber',
      transformer: 'numerical'
    },
    {
      property: 'facility',
      label: 'tenantCode'
    },
    {
      property: 'admitting_provider_name',
      label: 'providerName'
    }
  ]
};

export const AUTHENTICATOR_PROVIDER_NUMBER: CMxCommonApp.PatientDataDefinition = {
  key: 'assigned_document_auth_number',
  label: 'Authenticator Provider ID',
  property: 'assigned_document_auth_number',
  dataSize: 'l',
  dataSizeHorizontalView: 'l'
};

export const SERVICE_LINE: CMxCommonApp.PatientDataDefinition = {
  key: 'service_line',
  label: 'Service Line',
  property: 'service_line',
  transformer: 'service_line',
  dataSize: 'l',
  dataSizeHorizontalView: 'l'
};

export const HEALTH_SYSTEM: CMxCommonApp.PatientDataDefinition = {
  key: 'health_system_code',
  label: 'Health System',
  property: 'health_system_code',
  dataSize: 'l',
  dataSizeHorizontalView: 'l'
};

export const ADMISSION_DATE: CMxCommonApp.PatientDataDefinition = {
  key: 'admission_datetime',
  label: 'Admission Date',
  property: 'admission_datetime',
  dataSize: 'l',
  dataSizeHorizontalView: 'l',
  transformer: 'date_of_service',
  fieldType: 'date'
};

export const DISCHARGE_DATE: CMxCommonApp.PatientDataDefinition = {
  key: 'discharge_datetime',
  label: 'Discharge Date',
  property: 'discharge_datetime',
  dataSize: 'l',
  dataSizeHorizontalView: 'l',
  transformer: 'date_of_service',
  fieldType: 'date'
};

export const EM_CATEGORY: CMxCommonApp.PatientDataDefinition = {
  key: 'em_category',
  label: 'Case E/M Category',
  property: 'em_category',
  dataSize: 'l',
  dataSizeHorizontalView: 'l',
  fieldType: 'dictionary'
};

export const SERVICE_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'service_provider_name',
  label: 'Authoring Provider',
  property: 'primary_activity_provider_name',
  dataSize: 'l',
  dataSizeHorizontalView: 'l'
};

export const AUTHORING_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'authoring_provider_name',
  label: 'Authoring Provider',
  property: 'primary_activity_provider_name',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l',
  hasLink: true,
  additionalInfo: [
    {
      property: 'primary_activity_provider_number',
      label: 'providerNumber'
    },
    {
      property: 'facility',
      label: 'tenantCode'
    },
    {
      property: 'primary_activity_provider_name',
      label: 'providerName'
    }
  ]
};

export const FINAL_SIGNING_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'note_final_sign_provider',
  label: 'Final Sign Provider',
  property: 'note_final_sign_provider_name',
  dataSize: 'l',
  dataSizeHorizontalView: 'l',
  hasLink: true,
  additionalInfo: [
    {
      property: 'note_final_sign_provider_number',
      label: 'providerNumber'
    },
    {
      property: 'facility',
      label: 'tenantCode'
    },
    {
      property: 'note_final_sign_provider_name',
      label: 'providerName'
    }
  ]
};

export const NOTE_SPECIALTY: CMxCommonApp.PatientDataDefinition = {
  key: 'note_specialty_designation',
  label: 'NOTE SPECIALTY',
  property: 'note_specialty_designation',
  dataSize: 'l',
  dataSizeHorizontalView: 'l',
  fieldType: 'dictionary'
};

export const AGE: CMxCommonApp.PatientDataDefinition = {
  key: 'patient-dob',
  label: 'Age',
  property: 'date_of_birth',
  transformer: 'age',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const SCHEDULING_ID: CMxCommonApp.PatientDataDefinition = {
  key: 'scheduling_id',
  label: 'SCHEDULING ID',
  property: 'order_filler_number',
  transformer: 'numerical',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const OWNER: CMxCommonApp.PatientDataDefinition = {
  key: 'owner',
  label: 'CODER',
  property: 'owner',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const ASSIGNEE: CMxCommonApp.PatientDataDefinition = {
  key: 'assignee',
  label: 'ASSIGNEE',
  property: 'assignee',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const AGING_DAYS: CMxCommonApp.PatientDataDefinition = {
  key: 'aging_days',
  label: 'AGING DAYS',
  property: 'aging_days',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const CODABLE_DAYS: CMxCommonApp.PatientDataDefinition = {
  key: 'codable_days',
  label: 'CODABLE DAYS',
  property: 'codable_days',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const PATIENT_AGE: CMxCommonApp.PatientDataDefinition = {
  key: 'patient_age',
  label: 'Patient Age',
  property: 'patient_age',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l',
  transformer: 'patient_age_by_dos_dob'
};

export const ATTENDING_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'attending_provider_name',
  label: 'Attending Provider',
  property: 'attending_provider_name',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l',
  hasLink: true,
  additionalInfo: [
    {
      property: 'attending_provider_number',
      label: 'providerNumber',
      transformer: 'numerical'
    },
    {
      property: 'facility',
      label: 'tenantCode'
    },
    {
      property: 'attending_provider_name',
      label: 'providerName'
    }
  ]
};

export const CQA_IMPORT_ID: CMxCommonApp.PatientDataDefinition = {
  key: 'import_id',
  label: 'Import ID',
  property: 'import_id',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

export const NEW_OR_ESTABLISHED: CMxCommonApp.PatientDataDefinition = {
  key: 'new_or_established',
  label: 'New or Established',
  property: 'new_or_established',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};

// column groups for amplify

export const radAmplifyColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [DOB_AGE_BY_DOS, GENDER, MRN, PRIMARY_INSURANCE],
  summary: [
    ACCESSION,
    EXAM_CODE,
    REASON_FOR_VISIT,
    DOS,
    EXAM_DESCRIPTION,
    ORDERING_PROVIDER,
    ORDERING_PROVIDER_NUMBER,
    ORDER_NUMBER,
    PLACE_OF_SERVICE,
    TENANT_NAME,
    BILLING_AREA,
    BILLING_PROVIDER,
    BILLING_PROVIDER_NUMBER,
    PROCEDURE_TYPE,
    VISIT_NUMBER,
    CASE_ID
  ],
  expanded: []
};

export const PatientTimelineColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [DOB, GENDER, MRN, PRIMARY_INSURANCE],
  summary: [],
  expanded: []
};

const pathAmplifyColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [...radAmplifyColumns.patient],
  summary: [
    ACCESSION,
    CASE_TYPE,
    DOS,
    SPECIMEN_SOURCES,
    ORDERING_PROVIDER,
    ORDERING_PROVIDER_NUMBER,
    ORDER_NUMBER,
    {
      ...PLACE_OF_SERVICE,
      transformer: 'multi_place_of_service'
    },
    TENANT_NAME,
    BILLING_PROVIDER,
    BILLING_PROVIDER_NUMBER,
    GROUPER,
    ENCOUNTER_NUMBER,
    PROCESS_ID,
    CASE_ID
  ],
  expanded: []
};

const surgicalAmplifyColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [...radAmplifyColumns.patient],
  summary: [
    SERVICE_LINE,
    DOS,
    ENCOUNTER_NUMBER,

    NOTE_SPECIALTY,
    ORDER_NUMBER,
    {
      ...PROCEDURE_TYPE_CATEGORY,
      dataSize: 'ms',
      label: 'Scheduled Description'
    },

    ADMISSION_DATE,
    DISCHARGE_DATE,
    SCHEDULING_ID,

    FINANCIAL_STATUS_CLASS,
    PATIENT_CLASS,
    PATIENT_TYPE,

    ATTENDING_PROVIDER,
    AUTHENTICATOR_PROVIDER,
    AUTHORING_PROVIDER,
    { ...FINAL_SIGNING_PROVIDER, property: 'authentication_person_name' },

    ORDERING_PROVIDER,
    CASE_ID,

    FACILITY,
    DEPARTMENT,
    BILLING_AREA,
    OWNER,
    ASSIGNEE,
    AGING_DAYS,
    CODABLE_DAYS,
    PATIENT_AGE
  ],
  expanded: []
};

const ipcAmplifyColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [DOB_AGE_BY_DOS, GENDER, MRN, PRIMARY_INSURANCE],
  summary: [
    HAR,
    DOS,
    ADMISSION_DATE,
    DISCHARGE_DATE,
    PATIENT_TYPE,
    FINANCIAL_STATUS_CLASS,
    NOTE_SPECIALTY,

    //SERVICE_PROVIDER,
    AUTHORING_PROVIDER,
    AUTHENTICATOR_PROVIDER,
    FINAL_SIGNING_PROVIDER,
    ADMITTING_PROVIDER,
    DEPARTMENT,
    ORDERING_PROVIDER,
    FACILITY,
    CASE_ID,
    OWNER,
    ASSIGNEE,
    PATIENT_CLASS,
    SERVICE_LINE,
    SCHEDULING_ID,
    EM_CATEGORY,

    AGING_DAYS,
    CODABLE_DAYS,
    ATTENDING_PROVIDER
  ],
  expanded: []
};

export const PatientAmplifyEncounterColumns: CMxCommonApp.PatientInformationConfigurationMap = {
  radiology: radAmplifyColumns,
  pathology: pathAmplifyColumns,
  surgery: surgicalAmplifyColumns,
  inpatientprofessionalcoding: ipcAmplifyColumns
};

// column groups for accelerate

export const radDashboardColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [DOB, GENDER, MRN, PRIMARY_INSURANCE],
  summary: [
    ACCESSION,
    EXAM_CODE,
    REASON_FOR_VISIT,
    DOS,
    EXAM_DESCRIPTION,

    ORDERING_PROVIDER,
    ORDERING_PROVIDER_NUMBER,
    ORDER_NUMBER,
    PLACE_OF_SERVICE,
    TENANT_NAME,
    BILLING_AREA,
    BILLING_PROVIDER,
    BILLING_PROVIDER_NUMBER,
    PROCEDURE_TYPE,
    VISIT_NUMBER,
    CASE_ID
  ],
  expanded: []
};

const pathDashboardColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [...radDashboardColumns.patient],
  summary: [
    ACCESSION,
    CASE_TYPE,
    DOS,
    SPECIMEN_SOURCES,

    ORDERING_PROVIDER,
    ORDERING_PROVIDER_NUMBER,
    ORDER_NUMBER,
    {
      ...PLACE_OF_SERVICE,
      transformer: 'multi_place_of_service'
    },
    TENANT_NAME,
    BILLING_PROVIDER,
    BILLING_PROVIDER_NUMBER,
    GROUPER,
    ENCOUNTER_NUMBER,
    PROCESS_ID,
    CASE_ID
  ],
  expanded: []
};

const surgicalDashboardColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [...radDashboardColumns.patient],
  summary: [
    SERVICE_LINE,
    DOS,
    ENCOUNTER_NUMBER,

    NOTE_SPECIALTY,
    ORDER_NUMBER,
    {
      ...PROCEDURE_TYPE_CATEGORY,
      dataSize: 'ms',
      label: 'Scheduled Description'
    },

    ADMISSION_DATE,
    DISCHARGE_DATE,
    SCHEDULING_ID,

    FINANCIAL_STATUS_CLASS,
    PATIENT_CLASS,
    PATIENT_TYPE,

    ATTENDING_PROVIDER,
    AUTHENTICATOR_PROVIDER,
    AUTHORING_PROVIDER,
    { ...FINAL_SIGNING_PROVIDER, property: 'authentication_person_name' },

    ORDERING_PROVIDER,
    CASE_ID,

    FACILITY,
    DEPARTMENT,
    BILLING_AREA,

    PATIENT_AGE
  ],
  expanded: []
};

const ipcDashboardColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [DOB_AGE_BY_DOS, GENDER, MRN, PRIMARY_INSURANCE],
  summary: [
    HAR,
    DOS,
    ADMISSION_DATE,
    DISCHARGE_DATE,
    PATIENT_TYPE,
    FINANCIAL_STATUS_CLASS,
    NOTE_SPECIALTY,

    //SERVICE_PROVIDER,
    AUTHORING_PROVIDER,
    AUTHENTICATOR_PROVIDER,
    FINAL_SIGNING_PROVIDER,
    ADMITTING_PROVIDER,
    DEPARTMENT,
    ORDERING_PROVIDER,
    FACILITY,
    CASE_ID,
    OWNER,
    ASSIGNEE,
    PATIENT_CLASS,
    SERVICE_LINE,
    SCHEDULING_ID,
    EM_CATEGORY,

    AGING_DAYS,
    CODABLE_DAYS,
    ATTENDING_PROVIDER
  ],
  expanded: []
};

export const PatientEncounterDashboardColumns: CMxCommonApp.PatientInformationConfigurationMap = {
  radiology: radDashboardColumns,
  pathology: pathDashboardColumns,
  surgery: surgicalDashboardColumns,
  inpatientprofessionalcoding: ipcDashboardColumns,
  patientTimeline: PatientTimelineColumns
};

// The encounter column reads from codebench.activeItem since this section is shared with the code bench
// Therefore the property is in snake case rather than camel case
export const PatientEncounterGradeBenchColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [],
  summary: [
    {
      ...DOS,
      transformer: 'age_on_date_of_service',
      label: 'Age on Date of Service'
    },
    GLOBAL_PERIOD,
    GENDER,
    PRIMARY_INSURANCE,
    HAR,
    {
      ...PATIENT_CLASS,
      fieldType: undefined
    },
    {
      ...FACILITY,
      property: 'facility',
      key: 'facility',
      fieldType: undefined
    },
    HEALTH_SYSTEM,
    SERVICE_LINE,
    {
      ...REASON_FOR_VISIT,
      property: 'visit_reason',
      key: 'visit_reason',
      dataSize: 'l'
    },
    PROCESS_ID,
    CQA_IMPORT_ID,
    {
      ...CASE_ID,
      label: 'Case ID',
      key: 'sd_case_id',
      property: 'sd_case_id'
    },
    { ...SPECIMEN_SOURCES, defaultHide: true },
    {
      ...EXAM_DESCRIPTION,
      property: 'exam_description',
      key: 'exam_description'
    },
    AGE,
    NEW_OR_ESTABLISHED
  ],
  expanded: []
};
